//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * 0.1\n\
 *\n\
 * @name czm_epsilon1\n\
 * @glslConstant\n\
 */\n\
const float czm_epsilon1 = 0.1;\n\
";
